import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "app/shared/services/api.service";
import { User } from "app/shared/models/user.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";

import { Subject, Subscription } from "rxjs";
import { LocalStorageService } from "app/shared/services/local-storage.service";
import { debounceTime, distinctUntilChanged, switchMap, } from 'rxjs/operators';

interface Section {
  id: string;
  name: string;
  course: string;
  isEditing: boolean;
}
interface Chapter {
  id: string;
  name: string;
  section: string;
  isEditing: boolean;
}
interface Topic {
  id: string;
  name: string;
  chapter: string;
  isEditing: boolean;
}

@Component({
  selector: "app-lms-layout",
  templateUrl: "./lms-layout.component.html",
  styleUrls: ["./lms-layout.component.scss"],
})
export class LmsLayoutComponent implements OnInit {
  section: any;
  chapter: any;
  topic: any;
  courseId: string;
  studentId: string;
  sections: any = [];
  selectedTopics: any = [];
  appsByTopic: any[] = [];
  topicId: any;
  courseData: any;
  activeCourseName: string = "";
  activeSectionName: string = "";
  activeChapterName: string = "";
  activeTopicName: string = "";
  activeSectionId: string = "";
  activeChapterId: string = "";
  activeTopicId: string = "";
  isReadMode: boolean = false;
  isSideBarHidden: boolean;
  user: User;
  teaching_time = new Date();

  // cdkDrag
  grandfathers: any[] = [
    {
      name: "Grandfather 1",
      children: [
        {
          name: "Father 1",
          children: [{ name: "Child 1" }, { name: "Child 2" }],
        },
        {
          name: "Father 2",
          children: [{ name: "Child 3" }, { name: "Child 4" }],
        },
      ],
    },
    {
      name: "Grandfather 2",
      children: [
        {
          name: "Father 4",
          children: [{ name: "Child 5" }, { name: "Child 6" }],
        },
        {
          name: "Father 5",
          children: [{ name: "Child 7" }, { name: "Child 8" }],
        },
      ],
    },
  ];
  operating_system: any;
  isLmsContent: boolean;
  total_chapters: any;
  total_topics: any;
  pending_teacher_topics: any = []
  pending_student_topics: any = []
  searchText$: Subject<string> = new Subject<string>();
  searchTerm: string = '';
  flattenedItems: any[] = [];
  options: Array<{ title: string, items: any[] }> = [];
  expandAll: boolean = false;
  slug :any

  currentTopicIndex: number = 0; // To keep track of the active topic
  chapters = []; // Array of chapters in the current section
  topics: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public toastr: ToastrService,
    private store: LocalStorageService,
    private cdr: ChangeDetectorRef
  ) {
    this.user = JSON.parse(localStorage.getItem("user"));
    const currentUrl = this.route.snapshot.url[0].path;
    this.operating_system = store.getItem("os");
    if(currentUrl ==='course') this.slug = this.route.snapshot.paramMap.get('slug') || '';
    else{
      this.route.queryParams.subscribe((params) => {
        this.slug = params["slug"];
        this.courseId = params["id"];
        this.studentId = params["studentId"];
      });

    }      
  }
  ngOnInit(): void {
    this.getCourseById(this.courseId || this.slug);
    this.getSectionsByCourse(this.courseId?this.courseId:this.slug);
    if(this.studentId) this.getPendingTopics(this.courseId?this.courseId:this.slug,this.studentId)
     this.searchText$.pipe(
      debounceTime(300), // Adjust debounce time as needed
      distinctUntilChanged(), // Only emit when the current value is different than the last
      switchMap(text => {
        this.searchTerm = text;    // Update the search term
        return this.api.search_sections_chapters_topics(this.courseId, text); // Return the API call observable
      })).subscribe((res:any) => {
      const { data } = res;
      this.options = [
        { title: 'Section', items: data?.sections || [] },
        { title: 'Chapter', items: data?.chapters || [] },
        { title: 'Topic', items: data?.topics || [] },
      ];
      this.flattenItems();
      this.cdr.detectChanges();
    });
  }
   onSearch(text: string) {
    if (!text) {
      this.flattenItems();
      return;
    }
    this.searchText$.next(text);
  }
  flattenItems(): void {
    this.flattenedItems = this.options.flatMap(option => 
      option.items.map(item => ({ ...item, category: option.title }))
    );
  }
   searchAndGetAppsInACourse() {
    if (this.searchTerm) { // Only proceed if text is provided
      this.api.searchAndGetAppsInACourse(this.courseId, this.searchTerm).subscribe((res: any) => {
        if (res.isSuccess) {
          this.appsByTopic = res.data.map((item) => item.app);
        }
      });
    }
  }
   selectItemfromSearchList(item) {
    switch (item.category) {
      case "Section":
        const selectedSection = this.sections.find(section => section._id === item._id);
        if (selectedSection) {
          this.activeBreadcrumb(selectedSection.name, selectedSection._id);
    
          // Check if there are chapters, and auto-activate the first chapter if no active chapter
          if (selectedSection.chapters && selectedSection.chapters.length > 0) {
            selectedSection.collapsed = true;
            selectedSection.chapters[0].collapsed = true;
            const firstChapter = selectedSection.chapters[0];
            this.activeBreadcrumb(
              selectedSection.name,
              selectedSection._id,
              firstChapter.name,
              firstChapter._id
            );
  
            // Check if there are topics and auto-activate the first topic if no active topic
            if (firstChapter.topics && firstChapter.topics.length > 0) {
              const firstTopic = firstChapter.topics[0];
              this.activeBreadcrumb(
                selectedSection.name,
                selectedSection._id,
                firstChapter.name,
                firstChapter._id,
                firstTopic.name,
                firstTopic._id
              );
              this.getAppsByTopic(firstTopic._id, firstChapter.topics);
            }
          }
        }
        break;
  
        case "Chapter":
          this.sections.forEach((section, sectionIndex) => {
            // Iterate through each chapter to find the matching one and capture the chapter index
            section.chapters.forEach((chapter, chapterIndex) => {
              if (chapter._id === item._id) {
                this.sections[sectionIndex].collapsed = true;  // Expand the section
                this.activeBreadcrumb(section.name, section._id, chapter.name, chapter._id);
        
                // Auto-activate the first topic of the chapter if no active topic
                if (chapter.topics && chapter.topics.length > 0) {
                  this.sections[sectionIndex].chapters[chapterIndex].collapsed = true;  // Expand the chapter
                  const firstTopic = chapter.topics[0];
                  this.activeBreadcrumb(
                    section.name,
                    section._id,
                    chapter.name,
                    chapter._id,
                    firstTopic.name,
                    firstTopic._id
                  );
                  this.getAppsByTopic(firstTopic._id, chapter.topics);
                }
              }
            });
          });
          break;
        
      case "Topic":
        this.sections.forEach((section,sectionIndex) => {
          section.chapters.forEach((chapter,chapterIndex) => {
            const selectedTopic = chapter.topics.find(topic => topic._id === item._id);
            if (selectedTopic) {
              this.sections[sectionIndex].collapsed = true;
              this.sections[sectionIndex].chapters[chapterIndex].collapsed = true;
              this.activeBreadcrumb(
                section.name,
                section._id,
                chapter.name,
                chapter._id,
                selectedTopic.name,
                selectedTopic._id
              );
              this.getAppsByTopic(selectedTopic._id, chapter.topics);
            }
          });
        });
        break;
  
      default:
        // No category matched
        break;
    }
  }
  getAppsByTopic(id, topics?) {
    let pageSize = 25;
    let pageNo = 1;
    this.topicId = id;
    this.selectedTopics = topics;
    this.api.getAppsByTopic(id, pageSize, pageNo).subscribe((res: any) => {
      if (res.isSuccess) {
        if (
          this.operating_system === "Android" ||
          this.operating_system === "iOS"
        ) {
          if (this.isSideBarHidden === true) {
            this.isSideBarHidden = false;
          }
          if (this.isSideBarHidden === false) {
            this.isSideBarHidden = true;
          }
          this.isDivVisible = false;
          this.isLmsContent = false;
        }
        this.appsByTopic = res.data.map((item) => item.app);
        if (this.isReadMode) this.isSideBarHidden = !this.isSideBarHidden;
      }
    });
  }
  activeBreadcrumb(
    sectionName?,
    sectionId?,
    chapterName?,
    chapterId?,
    topicName?,
    topicId?
  ) {
    (this.activeSectionName = sectionName),
      (this.activeChapterName = chapterName),
      (this.activeTopicName = topicName);
    (this.activeSectionId = sectionId),
      (this.activeChapterId = chapterId),
      (this.activeTopicId = topicId);
  }
  getSectionsByCourse(id, studentId?) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.api.getSectionsByCourse(id, studentId).subscribe((res: any) => {
      if (res.isSuccess) {
        this.spinner.hide();
        this.sections = res?.data?.sections;
        this.sections[0].collapsed = true;
        this.sections[0].chapters[0].collapsed = true;
        this.total_chapters = res?.data?.allChapters;
        this.total_topics = res?.data?.allTopics;

        let topic_id = this.sections[0]?.chapters[0]?.topics[0]?._id;
        let topics = this.sections[0]?.chapters[0]?.topics;

        this.getAppsByTopic(topic_id, topics);

        this.activeSectionName = this.sections[0].name;
        this.activeSectionId = this.sections[0]._id;
        this.activeChapterName = this.sections[0].chapters[0].name;
        this.chapters =  this.sections[0].chapters
        this.activeChapterId = this.sections[0].chapters[0]._id;
        this.activeTopicName = this.sections[0].chapters[0].topics[0].name;
        this.activeTopicId = this.sections[0].chapters[0].topics[0]._id;
        this.activeBreadcrumb(
          this.activeSectionName,
          this.activeSectionId,
          this.activeChapterName,
          this.activeChapterId,
          this.activeTopicName,
          this.activeTopicId
        );
      }
    });
  }

  getCourseById(id) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.api.getCourseById(id).subscribe((res: any) => {
      this.spinner.hide();
      this.courseData = res.data;
      this.activeCourseName = res?.data[0]?.title;
    });
  }
  
  submit() {
    this.modalService.dismissAll(this.teaching_time);
    // if (time.value !== "") {
    //   var hours = time.split(":")[0];
    //   var minutes = time.split(":")[1];
    //   var suffix = hours >= 12 ? "pm" : "am";
    //   hours = hours % 12 || 12;
    //   hours = hours < 10 ? "0" + hours : hours;

    //   var displayTime = hours + ":" + minutes + " " + suffix;
    //   alert(displayTime)
    // }
  }
  // cdkDrag

  isDivVisible: boolean = true;

  toggleVisibility() {
    if (
      this.operating_system === "Windows" ||
      this.operating_system === "Mac"
    ) {
      this.isDivVisible = !this.isDivVisible;
    }
    if (
      this.operating_system === "Android" ||
      this.operating_system === "iOS"
    ) {
      this.isSideBarHidden = false;
      this.isDivVisible = true;
      if (this.isLmsContent === true) {
        this.isLmsContent = false;
      }
      if (this.isLmsContent === false) {
        this.isLmsContent = true;
      }
    }
  }
   getPendingTopics(course,student) {
    this.api.getPendingTopicByUserId(course,student,'teacher','').subscribe((res: any) => {
      this.pending_teacher_topics = res?.data
    })
     this.api.getPendingTopicByUserId(course,student,'','student').subscribe((res: any) => {
      this.pending_student_topics = res?.data
    })
  }
  isTeacherPendingTopic(id): boolean {
    return this.pending_teacher_topics?.some((item) => item.topic_id === id)
  }
  isStudentPendingTopic(id): boolean {
    return this.pending_student_topics?.some((item) => item.topic_id === id)
  }
  toggleExpandAll(expand: boolean) {
    this.expandAll = expand;
    this.sections.forEach(section => {
      section.collapsed = !expand;
      section.chapters.forEach(chapter => {
        chapter.collapsed = !expand;
      });
    });
  }

  // To handle previous button click
  // goToPreviousTopic() {
  //   if (this.currentTopicIndex > 0) {
  //     this.currentTopicIndex--;
  //     this.updateActiveTopic();
  //   }
  // }

  // To handle next button click
  // goToNextTopic() {
  //   this.selectedTopics
  //   if (this.currentTopicIndex < this.selectedTopics.length - 1) {
  //     this.currentTopicIndex++;
  //     this.updateActiveTopic();
  //   }
  // }

  // // Method to update active topic
  // updateActiveTopic() {
  //   const activeTopic = this.selectedTopics[this.currentTopicIndex];
  //   // Any additional logic to fetch data or content based on the active topic
  //   this.activeTopicName = activeTopic.name;
  //   this.topicId = activeTopic._id;
  //   this.getAppsByTopic(this.topicId,this.selectedTopics)
  // }
  

  // goToNextTopic() {
  
  //   const currentChapterIndex = this.chapters.findIndex(
  //     (chapter) => chapter.name === this.activeChapterName,
  //   );
  //   const currentSectionIndex = this.sections.findIndex(
  //     (section) => section.name === this.activeSectionName
  //   );
  
  //   // Check if there are more topics in the current chapter
  //   if (this.currentTopicIndex < this.selectedTopics.length - 1) {
  //     this.currentTopicIndex++;
  //   } else if (currentChapterIndex < this.chapters.length - 1) {
  //     // Move to the first topic of the next chapter in the same section
  //     this.activeChapterName = this.chapters[currentChapterIndex + 1].name;
  //     this.topics = this.chapters[currentChapterIndex + 1].topics;
  //     this.currentTopicIndex = 0;
  //   } else if (currentSectionIndex < this.sections.length - 1) {
  //     // Move to the first chapter of the next section
  //     this.activeSectionName = this.sections[currentSectionIndex + 1].name;
  //     this.chapters = this.sections[currentSectionIndex + 1].chapters;
  //     this.activeChapterName = this.chapters[0].name;
  //     this.topics = this.chapters[0].topics;
  //     this.currentTopicIndex = 0;
  //   } else {
  //     // Reached the end of all sections
  //     alert('You have completed all topics!');
  //     return; // Exit early
  //   }
  
  //   // Fallback to selectedTopics if no topics are available
  //   if (!this.topics || this.topics.length === 0) {
  //     this.topics = this.selectedTopics || [];
  //   }
  
  //   this.updateActiveTopic();
  // }
  goToPreviousTopic() {
    const currentChapterIndex = this.chapters.findIndex(
      (chapter) => chapter.name === this.activeChapterName,
    );
    const currentSectionIndex = this.sections.findIndex(
      (section) => section.name === this.activeSectionName
    );
  
    // Check if there are previous topics in the current chapter
    if (this.currentTopicIndex > 0) {
      this.currentTopicIndex--;
    } else if (currentChapterIndex > 0) {
      // Move to the last topic of the previous chapter in the same section
      this.activeChapterName = this.chapters[currentChapterIndex - 1].name;
      this.topics = this.chapters[currentChapterIndex - 1].topics;
      this.currentTopicIndex = this.topics.length - 1;
    } else if (currentSectionIndex > 0) {
      // Move to the last chapter of the previous section
      this.activeSectionName = this.sections[currentSectionIndex - 1].name;
      this.chapters = this.sections[currentSectionIndex - 1].chapters;
      this.activeChapterName = this.chapters[this.chapters.length - 1].name;
      this.topics = this.chapters[this.chapters.length - 1].topics;
      this.currentTopicIndex = this.topics.length - 1;
    } else {
      // Reached the beginning of all sections
      alert('You are at the first topic!');
      return; // Exit early
    }
  
    // Fallback to selectedTopics if no topics are available
    if (!this.topics || this.topics.length === 0) {
      this.topics = this.selectedTopics || [];
    }
  
    this.updateActiveTopic();
  }
  
  // updateActiveTopic() {
  //   if (this.topics && this.topics[this.currentTopicIndex]) {
  //     this.activeTopicName = this.topics[this.currentTopicIndex].name;
  //     this.topicId = this.selectedTopics[this.currentTopicIndex]._id;
  //     this.getAppsByTopic(this.topicId,this.topics)
  //   } else {
  //     console.warn('No topic found for the current index:', this.currentTopicIndex);
  //   }
  // }
  goToNextTopic() {
    const currentChapterIndex = this.chapters.findIndex(
      (chapter) => chapter.name === this.activeChapterName
    );
    const currentSectionIndex = this.sections.findIndex(
      (section) => section.name === this.activeSectionName
    );
  
    // First, update the current topic (before navigating)
    this.updateActiveTopic();
  
    // Check if there are more topics in the current chapter
    if (this.currentTopicIndex < this.selectedTopics.length - 1) {
      this.currentTopicIndex++;
    } else if (currentChapterIndex < this.chapters.length - 1) {
      // Move to the first topic of the next chapter in the same section
      this.activeChapterName = this.chapters[currentChapterIndex + 1].name;
      this.topics = this.chapters[currentChapterIndex + 1].topics;
      this.currentTopicIndex = 0;
    } else if (currentSectionIndex < this.sections.length - 1) {
      // Move to the first chapter of the next section
      this.activeSectionName = this.sections[currentSectionIndex + 1].name;
      this.chapters = this.sections[currentSectionIndex + 1].chapters;
      this.activeChapterName = this.chapters[0].name;
      this.topics = this.chapters[0].topics;
      this.currentTopicIndex = 0;
    } else {
      // Reached the end of all sections
      alert('You have completed all topics!');
      return; // Exit early
    }
  
    // Fallback to selectedTopics if no topics are available
    if (!this.topics || this.topics.length === 0) {
      this.topics = this.selectedTopics || [];
    }
  
    this.updateActiveTopic();
  }
  
  updateActiveTopic() {
    if (this.topics && this.topics[this.currentTopicIndex]) {
      this.activeTopicName = this.topics[this.currentTopicIndex].name;
      this.topicId = this.selectedTopics[this.currentTopicIndex]?._id;
      this.getAppsByTopic(this.topicId, this.topics);
    } else {
      console.warn('No topic found for the current index:', this.currentTopicIndex);
    }
  }
  
  
 
}
